export default {_name:'text.status',module:'Field',view:'Element/Text/Status',options:{md:1},mobileOptions:{ms:1}}